export const FOUNDER_CARD_TEMPLATES = [
  "glass-portrait",
  "split-quote",
  "circle-soft",
  "full-bleed",
] as const;

export type FounderCardTemplate = (typeof FOUNDER_CARD_TEMPLATES)[number];

export const FOUNDER_CARD_TEMPLATE_OPTIONS: Array<{
  id: FounderCardTemplate;
  label: string;
  description: string;
}> = [
  {
    id: "glass-portrait",
    label: "Glass portrait",
    description: "Centered photo with quote in a glass panel",
  },
  {
    id: "split-quote",
    label: "Split quote",
    description: "Photo on the left, quote on the right",
  },
  {
    id: "circle-soft",
    label: "Circle soft",
    description: "Circular photo with a soft card",
  },
  {
    id: "full-bleed",
    label: "Full bleed",
    description: "Wide photo on top, text below",
  },
];

export function normalizeFounderCardTemplate(
  template: string | undefined | null
): FounderCardTemplate {
  const trimmed = (template ?? "").trim();
  if ((FOUNDER_CARD_TEMPLATES as readonly string[]).includes(trimmed)) {
    return trimmed as FounderCardTemplate;
  }
  return "glass-portrait";
}
